/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchCatalog from "./catalogsearch/catalog/index";
import liveSearchFacets from "./catalogsearch/facets/index";
import liveSearchHelper from "./catalogsearch/helper/index";
import liveSearchProducts from "./catalogsearch/products/index";
import liveSearchSort from "./catalogsearch/sort/index";
import liveSearchUrl from "./catalogsearch/url/index";
import liveSearchGender from "./catalogsearch/gender";
import liveSearchDataLayer from "./catalogsearch/datalayer";

document.addEventListener('alpine:init', () => {
    Alpine.data('catalogSearch', function () {
        return {
            ...window.liveSearchConfig,
            ...liveSearchCatalog,
            ...liveSearchFacets,
            ...liveSearchHelper,
            ...liveSearchProducts,
            ...liveSearchSort,
            ...liveSearchGender,
            ...liveSearchUrl,
            ...liveSearchDataLayer,
            // Store properties in local storage
            facets: Alpine.$persist([]).as("liveSearchFacets"),
            clickedProductSelector: Alpine.$persist("").as("liveSearchClickedProductSelector"),
            clickedProductPage: Alpine.$persist(1).as("liveSearchClickedProductPage"),
            selectedFacets: Alpine.$persist([]).using(sessionStorage).as("liveSearchSelectedFacets"),
            lastVisitedCategoryPath: Alpine.$persist("").using(sessionStorage).as("liveSearchLastVisitedCategoryPath"),
            selectedSortOptionParams: Alpine.$persist({}).as("liveSearchSelectedSortOptionParams"),
            init() {
                this.checkViewPort();
                this.initCatalog();
                this.initSort();
                this.initGender();
            }
        };
    });
});
